var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3526 5.29845H9.74932V11.0698L14.037 15.3708L15.8762 13.5202L12.3526 9.98242V5.29845ZM11.051 0.0708008C5.29894 0.0708008 0.637695 4.75085 0.637695 10.5261C0.637695 16.3013 5.29894 20.9814 11.051 20.9814C16.803 20.9814 21.4643 16.3013 21.4643 10.5261C21.4643 4.75085 16.803 0.0708008 11.051 0.0708008ZM11.051 18.3676C6.73988 18.3676 3.24102 14.8546 3.24102 10.5261C3.24102 6.1976 6.73988 2.68462 11.051 2.68462C15.3621 2.68462 18.8609 6.1976 18.8609 10.5261C18.8609 14.8546 15.3621 18.3676 11.051 18.3676Z",
    fill: "#F0EAE1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.83347c9eb6107c9b54e041874d0005a1.svg";
export { ForwardRef as ReactComponent };